import { createContext, ReactElement, ReactNode, useContext } from 'react';

export interface ICasinoProvidersSearch {
  searchValue: string;
  setSearchValue: (value: string) => void;
}

export interface ICasinoProvidersSearchProps {
  children: ReactNode;
  value: ICasinoProvidersSearch;
}

const defaultConfigs: ICasinoProvidersSearch = {
  searchValue: '',
  setSearchValue: () => {}
};

const CasinoProvidersSearchContext =
  createContext<ICasinoProvidersSearchProps['value']>(defaultConfigs);

export const CasinoProvidersSearchProvider = (
  props: ICasinoProvidersSearchProps
): ReactElement => {
  return (
    <CasinoProvidersSearchContext.Provider value={props.value}>
      {props.children}
    </CasinoProvidersSearchContext.Provider>
  );
};

export const useCasinoProvidersSearchValues =
  (): ICasinoProvidersSearchProps['value'] => {
    return useContext(CasinoProvidersSearchContext);
  };
